const Color = {
  borderColor: "#709443",
  pointcolor: "#119518",
  cardBoxShadow: "rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em"
}

export default Color;